module.exports = __webpack_public_path__ + "c7324cf0ae0d85733b736f6e069be44b.png";


//////////////////
// WEBPACK FOOTER
// ./pages/news/6/futr_london.png
// module id = 247
// module chunks = 0